/* dbo-f001.js — generated by build.py from f001-funnelish-rebuild.html */
/* Source-HTML scripts stripped at assemble.py (tracking + Funnelish-pay). */
/* UTM passthrough JS targets a[href*='reploedge.com']. */
/* DO NOT EDIT BY HAND — re-run build.py after editing source HTML. */


/* UTM passthrough: forward ad UTMs from this advertorial to Reploedge so attribution
   survives the redirect to the offer page. */
(function () {
  var params = window.location.search;
  if (!params) return;
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[href*="reploedge.com"]').forEach(function (a) {
      var sep = a.href.indexOf('?') === -1 ? '?' : '&';
      a.href += sep + params.replace(/^\?/, '');
    });
  });
})();

/* Sticky-show-after: replicates Funnelish's setupSticky() behavior — toggles .visible
   on .sticky_show_after elements once scroll passes data-show_after threshold (default 1000).
   CSS already in place: .sticky_show_after { display:none } + .visible { display:flex }. */
(function () {
  function init() {
    var els = document.querySelectorAll('.sticky_show_after');
    if (!els.length) return;
    function check() {
      var y = window.scrollY || window.pageYOffset || 0;
      els.forEach(function (el) {
        var threshold = parseInt(el.getAttribute('data-show_after') || '1000', 10);
        el.classList.toggle('visible', y >= threshold);
      });
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Dynamic publish date: replaces #fiveDaysAgo placeholder with today-minus-5-days,
   formatted en-US long (e.g. "Friday, May 22, 2026"). Original Funnelish inline
   script was stripped at assemble.py; this restores the behavior so the byline
   stays evergreen across days. */
(function () {
  function init() {
    var els = document.querySelectorAll('#fiveDaysAgo');
    if (!els.length) return;
    var d = new Date();
    d.setDate(d.getDate() - 5);
    var s = d.toLocaleDateString('en-US', {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
    });
    els.forEach(function (el) { el.textContent = s; });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

